export const LABELS = {
  PAST_EFFECTIVE_DATE: 'Date/Time Posting Effective cannot be in the past.',
  POSTING_DATE_EXPIRE:
    'Date posting expire must be equal to or greater than the date posting effective.',
  POSTING_TIME_EXPIRE: 'Time posting expire must be greater than the time posting effective.',
  POSTING_TIME_EFFECTIVE: 'Time posting effective must be equal to or greater than the current time.',
  PAST_POSTING_EXPIRE: 'Posting date time expire must be greater than posting date time effective and posting date time expire should be today or greater',
  PAST_POSTING_TIME_EXPIRE: 'Time posting expire must be greater than current time'
};
